import maskit from "vue-the-mask/src/maskit";
import tokens from "vue-the-mask/src/tokens";

export default class {
    static it(value) {
        return maskit(value, '###.###.###-##', true, tokens)
    }

    static format(value, mask) {
        return maskit(value, mask, true, tokens)
    }
}
